import React, { Fragment, useEffect, useState } from "react";
import ResponsiveWrapper from "../_responsive-wrapper";
import Link from "@helpers/link";

const Breadcrumbs = ({ items, showWestCoast, isCustomCover }) => {
    const [hasWccInCurrentUrl, setHasWccInCurrentUrl] = useState(false);

    useEffect(() => {
        if (typeof window === "undefined") return;
        setHasWccInCurrentUrl(new URLSearchParams(window.location.search).has("wcc"));
    }, []);

    if (!items || items.length === 0) return null;

    const isWcc = showWestCoast || hasWccInCurrentUrl;

    const appendWccParam = (url) => {
        if (!url || url === "#") return url;
        if (url.includes("wcc")) return url;

        if (typeof window === "undefined") {
            const joiner = url.includes("?") ? "&" : "?";
            return `${url}${joiner}wcc=true`;
        }

        const nextUrl = new URL(url, window.location.origin);
        nextUrl.searchParams.set("wcc", "true");
        return `${nextUrl.pathname}${nextUrl.search}${nextUrl.hash}`;
    };

    let outputSourceItems = isWcc && items.length >= 2
        ? items.map((item) => ({ ...item, url: appendWccParam(item.url) }))
        : items;

    let mobileVisibleItems = outputSourceItems.length <= 2 ? outputSourceItems : [
        // eslint-disable-next-line no-script-url
        { title: "...", url: "#" },
        outputSourceItems[outputSourceItems.length - 2],
        outputSourceItems[outputSourceItems.length - 1],
    ];
    if (isCustomCover) {
        const customCoverItems = [
            outputSourceItems[1],
            outputSourceItems[2],
            outputSourceItems[3],
        ].filter(Boolean);

        mobileVisibleItems = customCoverItems;
        outputSourceItems = customCoverItems;
    }

    const outputItems = (_items) => _items.map((item, index) => (
        <Fragment key={item?.title}>
            {index > 0 && <div className="breadcrumbs__divider" />}
            <div className="breadcrumbs__link">
                <Link to={item.url} onClick={(e) => item?.onClick(e, item)}>{item.title}</Link>
            </div>
        </Fragment>
    ));

    return (
        <ResponsiveWrapper className="breadcrumbs">
            <div className="breadcrumbs__wrapper">
                <div className="breadcrumbs__desktop">
                    {outputItems(outputSourceItems)}
                </div>
                {/* Mobile view */}
                <div className="breadcrumbs__mobile">
                    {outputItems(mobileVisibleItems)}
                </div>
            </div>
        </ResponsiveWrapper>
    );
};

export default Breadcrumbs;
